import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
    selector: 'direct-root',
    template: '<router-outlet></router-outlet>',
    standalone: true,
    imports: [RouterOutlet]  // Standalone component must import RouterOutlet
})
export class AppDirectComponent {}
